import React, { useCallback } from 'react'
import {
  Container,
  FlagContainer
} from "./style";
import Flag from "react-world-flags";
import AmazonRestrictedInfo from "../AmazonRestrictedInfo";
import { Popover } from "@mui/material";
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';


const RestrictedField = (data: any) => {

  const { sellerID, isUsed } = data

  // Note: Restrictions and Listings are retrieved fro amazon_listings and amazon_items_restrictions using asins. 
  // This happens in the useRestrictionsAmazon function.
  // Markers to show whether a product has restrictions
  const isCARes = !!data.row?.original?.restrictions?.find((r: any) => r.marketplaceId === 2 && r.sellerId === sellerID && (isUsed ? r.isRestrictedUsed : r.isRestricted))
  const isUSRes = !!data.row?.original?.restrictions?.find((r: any) => r.marketplaceId === 1 && r.sellerId === sellerID && (isUsed ? r.isRestrictedUsed : r.isRestricted))

  // Add data to show whether it's listed
  // If there's no restriction and there's data for this store and condition in amazon_listings, show a checkmark
  // TODO: DISTINGUISH BETWEEN Inactive, Active, and Incomplete with active (0, 1, or 2)??
  const isUSListed = !!data.row?.original?.listings?.find((a: any) => a.marketplaceId === 1 && a.sellerId === sellerID && a.active === 1 && (isUsed ? a.condition === 'Used' : a.condition === 'New'))
  const isCAListed = !!data.row?.original?.listings?.find((a: any) => a.marketplaceId === 2 && a.sellerId === sellerID && a.active === 1 && (isUsed ? a.condition === 'Used' : a.condition === 'New'))

  const asin = data.row?.original?.asin
  const isNeedPopOver = isCARes || isUSRes

  const [anchorEl, setAnchorEl] = React.useState<HTMLDivElement | null>(null);

  const handleClick = useCallback((event: React.MouseEvent<HTMLDivElement>) => {
    asin && isNeedPopOver && setAnchorEl(event.currentTarget);
  }, [asin, isNeedPopOver]);

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <Container>
      <FlagContainer onClick={handleClick}>
        {isCARes && <Flag code={"CAN"} />}
        {!isCARes && isCAListed && <CheckRoundedIcon />}
      </FlagContainer>

      <FlagContainer onClick={handleClick}>
        {isUSRes && <Flag code={"USA"} />}
        {!isUSRes && isUSListed && <CheckRoundedIcon />}
      </FlagContainer>

      {asin && <Popover
        open={!!anchorEl}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <AmazonRestrictedInfo asin={asin} sellerId={data.sellerID} handlerClose={handleClose} isUsed={isUsed} />
      </Popover>}
    </Container>)
}

export default RestrictedField

